"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativePresetFilterItems = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var kebabCase_1 = tslib_1.__importDefault(require("lodash/kebabCase"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ListItem_1 = require("../ListItem/ListItem");
var ListHeading_1 = require("../ListHeading/ListHeading");
var RelativePresetTitleTranslated_1 = require("../RelativePresetTitleTranslated/RelativePresetTitleTranslated");
var DateFilterTextLocalized_1 = require("../DateFilterTextLocalized/DateFilterTextLocalized");
var granularityOrder = [
    "GDC.time.year",
    "GDC.time.quarter",
    "GDC.time.month",
    "GDC.time.week_us",
    "GDC.time.date",
    "GDC.time.hour",
    "GDC.time.minute",
];
/**
 * @internal
 */
exports.RelativePresetFilterItems = function (_a) {
    var dateFormat = _a.dateFormat, filterOption = _a.filterOption, selectedFilterOption = _a.selectedFilterOption, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange, className = _a.className;
    var relativePresets = granularityOrder
        .filter(function (granularity) {
        var _a;
        return Boolean(((_a = filterOption === null || filterOption === void 0 ? void 0 : filterOption[granularity]) === null || _a === void 0 ? void 0 : _a.length) > 0);
    })
        .map(function (granularity) { return ({
        granularity: granularity,
        items: filterOption[granularity],
    }); });
    return (react_1.default.createElement(react_1.default.Fragment, null, relativePresets.map(function (preset) { return (react_1.default.createElement(react_1.default.Fragment, { key: preset.granularity },
        react_1.default.createElement(ListHeading_1.ListHeading, { className: className },
            react_1.default.createElement(RelativePresetTitleTranslated_1.RelativePresetTitleTranslated, { granularity: preset.granularity })),
        preset.items.map(function (item) { return (react_1.default.createElement(ListItem_1.ListItem, { key: item.localIdentifier, isSelected: item.localIdentifier === selectedFilterOption.localIdentifier, onClick: function () { return onSelectedFilterOptionChange(item); }, className: classnames_1.default("s-relative-preset-" + kebabCase_1.default(item.localIdentifier), className) },
            react_1.default.createElement(DateFilterTextLocalized_1.DateFilterTextLocalized, { filter: item, dateFormat: dateFormat }))); }))); })));
};
//# sourceMappingURL=RelativePresetFilterItems.js.map